import { render, staticRenderFns } from "./Cockpit.vue?vue&type=template&id=47fbfed8"
import script from "./Cockpit.vue?vue&type=script&lang=js"
export * from "./Cockpit.vue?vue&type=script&lang=js"
import style0 from "./Cockpit.vue?vue&type=style&index=0&id=47fbfed8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports